import isArray from "lodash/fp/isArray";
import isObject from "lodash/fp/isObject";

import { tWrapper } from "hooks/useTranslation";

export default function translateNestedObject(i18n) {
  const t = tWrapper(i18n.t);

  function doNestedObject(value, name) {
    if (
      typeof name === "string" &&
      name.startsWith("t|") &&
      ((typeof value === "string" && value.length > 0) || value?.translationKey)
    ) {
      return t(value);
    }

    if (isArray(value)) {
      return value.map(doNestedObject);
    }

    if (isObject(value)) {
      return Object.keys(value).reduce((acc, key) => {
        return {
          ...acc,
          [key.replace(/^t\|/, "")]: doNestedObject(value[key], key),
        };
      }, {});
    }

    return value;
  }

  return doNestedObject;
}
